import React, { Component, Fragment } from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import ClearIcon from 'material-ui/svg-icons/content/clear';

import { alphaSort } from '../../../utils/helpers';

import debounce from 'lodash/debounce';

import { DateRangePicker } from 'react-dates';
import moment from 'moment';
// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';
import './filters.css';

/////////////////
// Text Filter //
/////////////////
function getTextFilter(field, fieldFilter) {
  return ({ filter, onChange }) => {
    return (
      <TextFilter
        field={field}
        filter={filter}
        fieldFilter={fieldFilter}
        onChange={onChange}
      />
    );
  };
}

class TextFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: ''
    };
  }

toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

  handleChange = (event, text) => {
    this.setState({ text });
    const debouncedOnChange = debounce(this.props.onChange, 350);
    debouncedOnChange(text);

  };

  clear = () => {
    if (this.props.fieldFilter.value) {
      this.setState({
        text: ''
      });
      this.props.onChange('');
    }
  };

  getInputStyle = () => {
    return null;
  };

  getClearStyle = () => {
    if (!this.props.fieldFilter || !this.props.fieldFilter.value || !this.state.text) {
      return { display: 'none' };
    }
  };


  render() {
    const filterValue = this.state.text || '';
    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <div className="clear-text-filter-wrapper">
          <ClearIcon
            className="clear-text-filter"
            style={this.getClearStyle()}
            onClick={this.clear}
          />
        </div>
        <TextField
          style={{ ...this.getInputStyle(), width: '100%' }}
          value={filterValue}
          name={this.props.field}
          fullWidth
          hintText="Type to filter"
          hintStyle={{
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

///////////////////
// Domain Filter //
///////////////////
function getDomainFilter(field, fields, fieldFilter) {
  const domainValues = fields[field].domain.codedValues;

  return ({ filter, onChange }) => {
    const getOptions = domainValues => {
      const values = filter ? filter.value : [];
      return domainValues
        .sort(alphaSort('name'))
        .map(d => (
          <MenuItem
            key={d.code}
            insetChildren={true}
            checked={values && values.indexOf(d.code) > -1}
            value={d.code}
            primaryText={d.name}
          />
        ));
    };

    const handleChange = (event, key, payload) => {
      if (payload.indexOf('any') !== -1) {
      }
      onChange(payload);
    };

    return (
      <SelectField
        style={{ textAlign: 'left' }}
        autoWidth
        fullWidth
        multiple={true}
        hintText="Select values"
        hintStyle={{
          width: '100%',
          paddingRight: '50px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
        value={filter ? filter.value : []}
        onChange={handleChange}
      >
        {getOptions(domainValues)}
      </SelectField>
    );
  };
}

///////////////////////
// Date Range Filter //
///////////////////////
function getDaterangeFilter(field, fieldFilter) {
  return ({ filter, onChange }) => {
    return (
      <DateFilter
        field={field}
        filter={filter}
        fieldFilter={fieldFilter}
        onChange={onChange}
      />
    );
  };
}

class DateFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: null,
      endDate: null,
      isOpen: false
    };
  }


  handleInputFocused = event => {
    event.preventDefault();

    this.setState({ focusedInput: 'startDate' });
  };

  handleDatesChanged = ({ startDate, endDate }) => {
    if (!startDate && !endDate) {
      // 'clear date' was clicked
      this.props.onChange([startDate, endDate, 'date']);
    }
    if (startDate && endDate) {
      const endTimeEpoch = endDate.unix()
      const startTimeEpoch = startDate.unix();
      this.props.onChange([startDate, endDate, 'date']);
      // this.props.filterMethod = (filter, row) => {
      //   if (filter.value[0] === null || filter.value[1] === null) {
      //     // Incomplet or cleared date picker
      //     return true
      //   }
      //
      //   if (moment(row[filter.id].props.datetime).isBetween(filter.value[0], filter.value[1])) {
      //     // Found row matching filter
      //     return true
      //   }
      // }
    }

    this.setState({ startDate, endDate});
  };



  handleCalendarClose = ({ startDate, endDate }) => {
     if (!startDate && !endDate) {
      // 'clear date' was clicked
      this.props.onChange([null, null, 'date']);
    } else{
    this.props.onChange([startDate, endDate, 'date']);
    }
  };

  handleFocusChange = focusedInput => {
    this.setState({ focusedInput });
  };

  clearDates = () => {
    if (this.state.startDate || this.state.endDate) {
      this.props.onChange([null, null, 'date']);
    }
    this.setState({ startDate: null, endDate: null });
  };

  getInputValue = () => {
    let startDate;
    let endDate;
    if (this.props.fieldFilter && this.props.fieldFilter.value) {
      startDate = this.props.fieldFilter.value[0];
      endDate = this.props.fieldFilter.value[1];
    }
    if (startDate && endDate) {
      const startLabel = startDate.format('M/D/YY');
      const endLabel = endDate.format('M/D/YY');
      return `${startLabel} - ${endLabel}`;
    }
    return '';
  };

  getInputStyle = () => {
    let startDate;
    let endDate;
    if (this.props.fieldFilter && this.props.fieldFilter.value) {
      startDate = this.props.fieldFilter.value[0];
      endDate = this.props.fieldFilter.value[1];
    }
    if (startDate && endDate) {
      return { fontSize: '0.8em' };
    }
    return null;
  };

  getClearStyle = () => {
    let startDate;
    let endDate;
    if (this.props.fieldFilter && this.props.fieldFilter.value) {
      startDate = this.props.fieldFilter.value[0];
      endDate = this.props.fieldFilter.value[1];
    }
    if (!startDate || !endDate) {
      return { display: 'none' };
    }
  };

  render() {
    const startDate =
      (this.props.fieldFilter && this.props.fieldFilter.value[0]) ||
      this.state.startDate;
    const endDate =
      (this.props.fieldFilter && this.props.fieldFilter.value[1]) ||
      this.state.endDate;

    return (
      <Fragment>
        <div style={{ position: 'relative' }}>
          <ClearIcon
            className="clear-date-filter"
            style={this.getClearStyle()}
            onClick={this.clearDates}
          />
          <TextField
            style={{ ...this.getInputStyle(), width: '100%' }}
            onFocus={this.handleInputFocused}
            fullWidth
            hintText="Select dates"
            hintStyle={{
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            value={this.getInputValue()}
          />
        </div>
        <div style={{ display: 'none ' }}>
          <DateRangePicker
            small
            showClearDates
            withPortal
            hideKeyboardShortcutsPanel
            isOutsideRange={() => false}
            startDate={startDate}
            startDateId="startDate"
            endDate={endDate}
            endDateId="endDate"
            onDatesChange={this.handleDatesChanged}
            focusedInput={this.state.focusedInput}
            onFocusChange={this.handleFocusChange}
            onClose={this.handleCalendarClose}
          />
        </div>
      </Fragment>
    );
  }
}

export { getTextFilter, getDomainFilter, getDaterangeFilter };



// WEBPACK FOOTER //
// ./src/components/common/DataGrid/filterCreators.js